import { FunctionComponent } from 'react';
import { View, Text } from '@upstox/upstox-ui';
import * as css from './FieldPair.style';

type Props = {
  label?: string;
  value?: string;
  isSeoApp?: boolean;
};

const FieldPair: FunctionComponent<Props> = ({
  label,
  value,
  isSeoApp = false,
}) => {
  return (
    <View flexDirection="column" css={css.item} cssProps={{ isSeoApp }}>
      {isSeoApp ? (
        <>
          <View css={css.label}>
            <Text size="m" color="text.2" weight="bold">
              {label}
            </Text>
          </View>
          <View>
            <Text variant="bodyBold" size="l">
              {value}
            </Text>
          </View>
        </>
      ) : (
        <>
          <View css={css.label}>
            <Text size="meta" color="text.2">
              {label}
            </Text>
          </View>
          <View>
            <Text>{value}</Text>
          </View>
        </>
      )}
    </View>
  );
};

export default FieldPair;
